export const hideMenu = () => {
  const el = document.getElementsByClassName('ig-sharemenu')[0].classList;
  el.remove('ig-sharemenu-show');
  el.add('ig-sharemenu-hidden');
  const bodyClass = document.getElementsByTagName('body')[0].classList;
  bodyClass.remove('fixedbody');
};

export const showMenu = () => {
  const el = document.getElementsByClassName('ig-sharemenu')[0].classList;
  el.remove('ig-sharemenu-hidden');
  el.add('ig-sharemenu-show');
  const bodyClass = document.getElementsByTagName('body')[0].classList;
  bodyClass.add('fixedbody');
};

export const standardProtocol = (url: string | undefined) => (url ? url.replace(/^http:/, 'https:') : '');

export const getTitle = (title?: string) => title
  || (window.document.getElementsByTagName('title')[0]
    ? window.document.getElementsByTagName('title')[0].innerText
    : '');

export const getUrl = (url: string | undefined) => standardProtocol(decodeURIComponent(url || `https://${window.location.host}${window.location.pathname}`));
